import React, { useRef, useEffect } from 'react'

export function FreeTextarea({ text = '', onChange, readOnly = false, placeholder = 'Capture anything…' }) {
  const ref = useRef(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.style.height = 'auto'
      ref.current.style.height = ref.current.scrollHeight + 'px'
    }
  }, [text])

  return (
    <div style={styles.wrap}>
      <textarea
        ref={ref}
        style={{ ...styles.textarea, opacity: readOnly ? 0.8 : 1 }}
        value={text}
        placeholder={readOnly ? '' : placeholder}
        disabled={readOnly}
        onChange={(e) => !readOnly && onChange({ text: e.target.value })}
        rows={4}
        aria-label="Shared notes"
      />
    </div>
  )
}

const styles = {
  wrap: { padding: '10px 12px 12px' },
  textarea: {
    width: '100%', border: 'none', outline: 'none', background: 'transparent',
    color: 'var(--text-primary)', resize: 'none', lineHeight: '1.6',
    fontSize: '12px', overflow: 'hidden', minHeight: '80px',
  },
}
